<!--
출고 작업
-->
<template>
    <div class="">

        <!-- 선택 일괄기능 -->
        <app-batch-controller 
            :batch="batch"    
            class="uk-margin-bottom"
        >
            <app-batch-job-shipout
                    slot="jobs"
                    :batch="batch"
                    :csrf-token="csrfToken"
                    :region-id="regionId"
            ></app-batch-job-shipout>
        </app-batch-controller>


        
        <div class="uk-card uk-card-default uk-card-small">
            <div class="uk-card-header">
                
                <h3 class="uk-card-title">출고대상 ({{items.length}})</h3>

                <div class="uk-card-badge">
                    <!-- EDI 엑셀다운 -->
                    <button
                            type="button"
                            class="uk-button uk-button-small uk-button-default"
                            onclick="$.app.on_event.down(arguments);"
                            data-confirm-msg="엑셀로 다운로드 하시겠습니까?"
                            :data-url="ediDownUrl"
                    >
                        <span uk-icon="icon: download" class="uk-icon"></span>
                        출고대상 EDI 엑셀다운
                    </button>
                </div>
            </div>
            <div class="uk-card-body app-table-normal">

                <!-- 리스트 -->
                <table class="uk-table uk-table-small uk-table-middle">
                <colgroup>
                    <col style="width: 60px">
                    <col style="width: 150px">

                    <col style="width: 120px">
                    <col style="width: 150px">
                    
                    <col>
                    <col>

                    <col style="width: 120px">
                    <col style="width: 200px">


                </colgroup>

                <thead>
                <tr>
                    <th scope="col" class="uk-text-center">
                        <app-batch-all-item-checker :items="batch.items"></app-batch-all-item-checker>
                    </th>
                    <th scope="col" class="uk-text-center">
                        배송코드
                    </th>

                    <th scope="col" class="uk-text-center">
                        배송단계
                    </th>
                    <th scope="col" class="uk-text-center">
                        수취인
                    </th>

                    <th scope="col" class="uk-text-center">
                        BLNO
                    </th>
                    <th scope="col" class="uk-text-center">
                        HAWB
                    </th>

                    <th scope="col" class="uk-text-center">
                        PACKAGE-QTY
                    </th>
                    <th scope="col" class="uk-text-center">
                        회원사서함
                    </th>

                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in items"
                    :key="index"
                >
                
                    <td class="uk-text-center">
                        <app-batch-item-checker :item="item.checkbox"></app-batch-item-checker>
                    </td>
                    <td class="uk-text-center">
                        {{ item.code }}

                        <!-- 상세링크 -->
                        <a 
                            class="uk-link" 
                            :href="'/prods/' + item.first_prod_id" 
                            target="_blank"
                            title="상품상세"
                        >
                            <span uk-icon="'ratio: 1; icon: link"></span>
                        </a>
                        
                    </td>

                    <td class="uk-text-center">
                        {{ item.state_text }}
                    </td>
                    <td class="uk-text-center">
                        {{ item.name }}
                    </td>

                    <td class="uk-text-center">
                        {{ item.blno }}
                    </td>
                    <td class="uk-text-center">
                        {{ item.hawb }}
                    </td>

                    <td class="uk-text-center">
                        {{ item.package_amount }}
                    </td>
                    <td class="uk-text-center">
                        {{ item.user_mailbox }}
                    </td>


                </tr>
                
                </tbody>
                </table>
            </div>
        </div>



      

    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 라라벨 csrf 토큰
             */
            csrfToken: {
                type: String,
                default: null,
            },
            /**
             * 하우스정보
             */
            items: {
                type: Array,
                default: [],
            },
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
            /**
             * edi 엑셀 포맷번호
             */
            ediFormat: {
                type: Number,
                default: null,
            },
        },
        data: function () {
            // batch items 생성 (전체선택에 사용할 일괄정보 객체)
            let batch_items = [];
            _.forEach(this.items, function (item) {
                let obj = {
                    id: item.id,
                    checked: false,

                    code: item.code,
                    id: item.id,
                    name: item.name,
                    state_text: item.state_text,
                    blno: item.blno,
                    hawb: item.hawb,
                    package_amount: item.package_amount,
                    user_nick: item.user_nick,
                    user_mailbox: item.user_mailbox,

                    first_prod_id: item.first_prod_id,
                };
                item.checkbox = obj;
                batch_items.push(obj);
            });
            return {
              
                // 전체선택에 사용할 일괄정보 객체
                batch: {
                    items: batch_items,
                    checked_item_count: 0,
                    item_checked_msg_format: 'checked :count items',
                    item_checked_nothing_msg: 'No item selected',
                },
            };
        },
        computed: {
            /**
             * edi 엑셀 다운url 작성
             */
            ediDownUrl: function () {
                return '/regions/'+
                    this.regionId+
                    '/houses?paging=no&__accept=excel&excel_format='+
                    this.ediFormat+
                    '&state=71';
            }
        },
        watch: {
        },
        mounted: function () {
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
</style>